interface StockStatusBadgeProps {
  inStock: "in-stock"|"out-of-stock"|"low-stock"
  quantity?: number
}

export const StockStatusBadge = ({ inStock, quantity }: StockStatusBadgeProps) => {
  const getStatusStyles = () => {
    return inStock ==="in-stock"
      ? 'bg-[#E1FEE3] text-[#03750B]' :
      inStock==="out-of-stock"
        ? 'bg-[#FECDCD] text-[#AB0303]'
        :"bg-[#FEFECD] text-[#7E7E02] "
  }

  const displayText = inStock === "in-stock"
    ? `In stock${quantity ? ` (${quantity})` : ''}` :
    inStock === "out-of-stock"?
      'Out of stock' : `Low stock${quantity ? ` (${quantity})` : ''}`

  return (
    <span className={`px-3 py-1 text-sm font-[600] rounded-lg min-w-[103px] h-[25px] rounded-[10px] ${getStatusStyles()}`}>
      {displayText}
    </span>
  )
}